import { config } from "../../config.mjs";
import { refresh } from "./hacksafari.mjs";

export function handleKeyboard() {
	window.addEventListener("keydown", function (event) {
		// Hack pour forcer un refresh sur Safari
		setTimeout(function () {
			refresh();
		}, 100);

		// Vérifie si la touche "Suppr" (Delete) est appuyée
		if (event.key === "Delete") {
			// Si un élément est sélectionné, le supprimer
			if (config.selected) {
				config.selected.remove(); // Supprime l'élément du DOM
				config.selected = false; // Réinitialise la variable
			}
		}
	});
}
